import React from 'react'
import { useTranslation } from 'react-i18next'

import { DropdownOptionSelection, FieldProps, Styles } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { DefaultRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'

const style: Styles = {
  padding: { paddingTop: 24 },
}

const PriceTypeField: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  screenName,
  insertionData,
  onChange,
}) => {
  const { t } = useTranslation()

  const property = 'priceType'
  const options = DefaultRentPriceTypeOption
  const value = insertionData.priceType?.value

  return (
    <div className='grid-item one-half padding-left-m margin-top-l' style={style.padding}>
      <DropdownSelect
        id='price-type'
        name={property}
        ariaLabel={t('wizard.screen.basicInfo.priceTypeLabel', 'Price type')}
        value={value}
        options={{
          translationKeyGroup: 'wizard.screen.basicInfo.priceTypeOptions',
          options: Object.keys(options),
        }}
        onChange={(value: DropdownOptionSelection) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default PriceTypeField
